module.exports = __webpack_public_path__ + "img/logo-tesoreria.20c6fc77.png";